export const creditCardLimitChange = {
    /** Display calculated authorized amount in the credit card header limit change component - calculated from availableAmounts field - positioned above progress bar */
    displayAuthorizedBalance: false,
    /** Display balance field in the credit card header limit change component - positioned above progress bar */
    displayBalance: false,
    /** Display drawAmount (outstandingAmount field) instead of the available amount (availableAmounts.availableCredit ?? balance) in the credit card header limit change component */
    displayDrawnAmount: false,
    /** Limits display of the credit card limit change card to the listed card types */
    types: [] as string[],
    showRemainingAmountInsteadOfSpentAmount: false,
};
